module.exports = new Promise(function (resolve, reject) {
    if (window['legacyWeb']) {
      resolve(window['legacyWeb']);
      return;
    }

    var appEnv = (window.__env__ && window.__env__['coreWeb']) || {};
    var host = appEnv['LEGACY_WEB_HOST'] || "";

    if (!host) {
      reject(new Error('Missing remote host: LEGACY_WEB_HOST'));
      return;
    }

    var src = host.replace(/\/$/, '') + '/remoteEntry.js';
    var existingScript = document.querySelector('script[data-webpack-runtime-remote="legacyWeb"]');

    if (existingScript) {
      existingScript.addEventListener('load', function () {
        resolve(window['legacyWeb']);
      });
      existingScript.addEventListener('error', function () {
        reject(new Error('Failed to load legacyWeb'));
      });
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.dataset.webpackRuntimeRemote = 'legacyWeb';
    script.onload = function () {
      resolve(window['legacyWeb']);
    };
    script.onerror = function () {
      reject(new Error('Failed to load legacyWeb'));
    };
    document.head.appendChild(script);
  });